import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 14 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L7 7L14 0H0Z", fill: "black" }));
export default SvgDown;
